import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { parseHttpErrorBody } from '../shared/forms/parse-http-error-body';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/Rx';

import {GlobalVariable} from '../global';
import {RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {Profile} from './profile.model';

@Injectable()
export class ProfileService {

  private profileData: Profile = new Profile();

  public profile: Subject<Profile> = new Subject<Profile>();

  constructor(private http: HttpClient) {
    this.profile.subscribe(
      (user) => {
        this.profileData = Object.assign({}, user);
      }
    );
  }

  getProfileData() {
    return Object.assign({}, this.profileData);
  }

  getProfile (parameters: RequestParameters = new RequestParameters(), update: boolean = false) {

    if (this.profileData.reference !== null && update === false) {
      return Observable.of(this.profileData);
    }

    return this.http.get(GlobalVariable.BASE_API_URL + '/profile', {
      params: parameters.getHttpParams()
    })
      .map(
        (response: Profile) => {
          this.profileData = response;
          this.profile.next(response);
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  putProfile (profile: Profile ) {
    const body = Object.assign({}, profile);
    delete body.reference;
    delete body.callCenter;
    delete body.username;
    if (profile.picture !== null) {
      body.picture = profile.picture.reference;
    }

    return this.http.patch(GlobalVariable.BASE_API_URL + '/profile', body)
      .map(
        (response: Profile) => {
          this.profile.next(response);
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            error: JSON.parse(error.error),
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  putPassword(pwd: object) {
    const body = Object.assign({}, pwd);
    return this.http.put(GlobalVariable.BASE_API_URL + '/profile/password', body)
      .map(
        (response: HttpResponse<any>) => {
          const profile: Profile = this.profileData;
          profile.lastChangePassword = (new Date()).toISOString();
          this.profile.next(profile);
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            error: JSON.parse(error.error),
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  hasPermission(permissionName: string): Observable<boolean> | Promise<boolean> {
    if (this.profileData.role === null) {
      return this.getProfile().map(
        (profile) => {
          return this.checkPermission(permissionName);
        }
      );
    } else {
      return Observable.of(this.checkPermission(permissionName));
    }
  }

  private checkPermission (permissionName: string): boolean {
    let hasPermission: boolean = false;
    for (const permission of this.profileData.role.permissions) {
      if (permission.name === permissionName) {
        hasPermission = true;
        break;
      }
    }
    return hasPermission;
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/profile/profile.service.ts